import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

export type RoomOverviewClassType = 'class' | 'private_lesson';

export interface RoomOverviewClass {
  classId: string;
  className: string;
  instructorName: string;
  startTime: string;
  endTime: string;
  locationName?: string;
  color: string;
  type?: RoomOverviewClassType;
  bookingId?: string;
  studentName?: string;
}

export interface RoomOverviewRoom {
  roomId: string;
  roomName: string;
  locationName?: string;
  classes: Array<RoomOverviewClass>;
}

export interface RoomOverviewResponse {
  date: string;
  rooms: Array<RoomOverviewRoom>;
  unassigned?: {
    classes: Array<RoomOverviewClass>;
    locationName?: string;
  };
}

export interface GetRoomOverviewParams {
  date: string;
  instructorIds?: Array<string>;
}

export const getRoomOverviewAPI = async (
  params: GetRoomOverviewParams,
): Promise<RoomOverviewResponse> => {
  const response = await baseAPI.get<RoomOverviewResponse>('room/overview', {
    params: {
      date: params.date,
      instructor:
        params.instructorIds && params.instructorIds.length > 0
          ? params.instructorIds.join(',')
          : undefined,
    },
  });

  return response.data;
};

export const getRoomOverviewOptions = (params: GetRoomOverviewParams) =>
  queryOptions({
    queryKey: QUERY_KEYS.ROOM_OVERVIEW(params),
    queryFn: () => getRoomOverviewAPI(params),
    staleTime: 1000 * 60 * 2,
  });

export const useGetRoomOverview = (params: GetRoomOverviewParams) =>
  useQuery({
    ...getRoomOverviewOptions(params),
    enabled: Boolean(params.date),
  });
